import React from "react";

function About() {
  return (
    <div>
      <div className="abt-header">
        <h1>About</h1>
      </div>
      <div className="abt-container">
        <p>
          Hello, Everyone needs a short vacation to enjoy time with your family
          and friends. There are sometimes when you can't take your furry
          friends with you and you don't with you but at the same time, you
          don't want to leave them alone at home.{" "}
        </p>
        <p>
          But don't worry <strong>Pet Boarding</strong> has got your back. Here
          you can find people in your area and can contact them and see if they
          can enjoy quality time with your furry friends while you are away.
        </p>
        <p>
          Pet Boarding is all about taking care of your furry friends. You can
          be away at work and people can take care of them.
        </p>
      </div>
    </div>
  );
}

export default About;
